import React from 'react';
import styles from './Skeleton.module.scss';

/**
 * Placeholder shimmer per gli stati di caricamento.
 *
 * Props:
 * - width / height: dimensioni (number=px o stringa CSS)
 * - radius:        border-radius (default --radius-sm)
 * - circle:        bool, forza forma circolare
 * - className/style
 */
export default function Skeleton({ width, height = 14, radius, circle, className = '', style }) {
  return (
    <span
      className={`${styles.skel} ${className}`}
      style={{
        width,
        height,
        borderRadius: circle ? '50%' : radius,
        ...style,
      }}
    />
  );
}

/** Righe skeleton per tabelle/liste in caricamento. */
export function SkeletonRows({ rows = 6 }) {
  return (
    <div className={styles.rows}>
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className={styles.row}>
          <Skeleton width={34} height={34} radius="var(--radius-sm)" />
          <Skeleton height={14} width={`${120 + (i % 3) * 40}px`} />
          <Skeleton height={14} width={90} style={{ marginLeft: 'auto' }} />
          <Skeleton height={22} width={80} radius="var(--radius-sm)" />
        </div>
      ))}
    </div>
  );
}
